import { render, staticRenderFns } from "./BlacklistedPhonesBlock.vue?vue&type=template&id=33cee3b8&scoped=true&"
import script from "./BlacklistedPhonesBlock.vue?vue&type=script&lang=js&"
export * from "./BlacklistedPhonesBlock.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistedPhonesBlock.vue?vue&type=style&index=0&id=33cee3b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cee3b8",
  null
  
)

component.options.__file = "BlacklistedPhonesBlock.vue"
export default component.exports